// src/hooks/useAddToRecent.js

import { useState, useEffect } from 'react';

/**
 * Handles adding an item to the recently watched list after a delay.
 * @param {object} params
 * @param {object} params.item - The media item.
 * @param {number|null} params.selectedSeason - The current season.
 * @param {number|null} params.selectedEpisode - The current episode.
 * @param {function} params.onAddToRecent - The callback function to add to recents.
 */
export default function useAddToRecent({ item, selectedSeason, selectedEpisode, onAddToRecent }) {
  const [hasBeenAdded, setHasBeenAdded] = useState(false);

  // Reset when the main item changes
  useEffect(() => {
    setHasBeenAdded(false);
  }, [item?.id]);

  // Effect to add to recents after a delay or update immediately
  useEffect(() => {
    if (!item || !onAddToRecent) return;

    // If it's already been added once, update immediately on episode/season change
    if (hasBeenAdded && item.media_type === 'tv') {
      onAddToRecent(item, selectedSeason, selectedEpisode);
      return;
    }

    // If not added yet, set a timer to add it for the first time
    const timer = setTimeout(() => {
      onAddToRecent(
        item,
        item.media_type === 'tv' ? selectedSeason : null,
        item.media_type === 'tv' ? selectedEpisode : null
      );
      setHasBeenAdded(true);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer);

  }, [item, selectedSeason, selectedEpisode, onAddToRecent, hasBeenAdded]);
}